//Utils.js
import $ from 'jquery';

function tokenVerification() {
    $.ajax({
        url: "/my-jeeva-api/login-token-verification",
        method: 'GET',
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
            if (res.success === true) {
                console.log("There is no error");
            }
            else {
                localStorage.removeItem("user_details");
                window.location.href = "/my-jeeva/login";
            }
        },
        error: function (xhr) {
            localStorage.removeItem("user_details");
            window.location.href = "/my-jeeva/login";
        }
    });
}

// Languages written right to left. Translation fields for these must be typed and shown RTL.
const RTL_LANGUAGES = ["AR", "HE", "FA", "UR"];

function isRtlLanguage(code) {
    return !!code && RTL_LANGUAGES.includes(String(code).toUpperCase());
}

// Value for a dir attribute or the CSS direction property
function textDirection(code) {
    return isRtlLanguage(code) ? "rtl" : "ltr";
}

export { tokenVerification, isRtlLanguage, textDirection };


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Utils.js